import { useEffect, useState } from "react"

export function useOnlineStatus(): {
  isOnline: boolean
  lastOnlineAt: Date | null
  showBackOnline: boolean
} {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  )
  const [lastOnlineAt, setLastOnlineAt] = useState<Date | null>(() => new Date())
  const [wasOffline, setWasOffline] = useState(false)
  const [showBackOnline, setShowBackOnline] = useState(false)

  useEffect(() => {
    const onOnline = () => {
      setIsOnline(true)
      setLastOnlineAt(new Date())
      if (wasOffline) {
        setShowBackOnline(true)
        window.setTimeout(() => setShowBackOnline(false), 3000)
      }
    }
    const onOffline = () => {
      setIsOnline(false)
      setWasOffline(true)
      setShowBackOnline(false)
    }

    window.addEventListener("online", onOnline)
    window.addEventListener("offline", onOffline)
    return () => {
      window.removeEventListener("online", onOnline)
      window.removeEventListener("offline", onOffline)
    }
  }, [wasOffline])

  return { isOnline, lastOnlineAt, showBackOnline }
}
